<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input_location_vacancy"
        size="sm"
        :state="state"
        :disabled="isDisabled"
        v-model="query"
        :placeholder="locationId && items.length === 0 ? 'Нет доступных вакансий' : 'Выберите шаблон вакансии'"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canEditLocationVacancies()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showRecruitLocationVacancy"
          v-b-tooltip.hover.v-success
          title="Создать шаблон вакансии"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-location-vacancy" v-if="isFocus">
        <b-list-group-item v-for="(item, index) in filteredItems" :key="index" @mousedown="onClick(item)" button>
          <div class="text-small">{{ item.vacancy_name }}</div>
          <div class="text-secondary text-small">Количество: {{ item.workers_count }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="filteredItems.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>

    <RecruitLocationVacancy ref="recruit_location_vacancy" @refresh="getItems"/>

  </div>
</template>

<script>
import locationVacancies from "../../network/locationVacancies";
  import permissions, {PERM} from "../../utilites/permissions";
    import RecruitLocationVacancy from "../Recruiting/RecruitLocationVacancy.vue";

export default {
  name: "LocationVacancySelect",
  components: { RecruitLocationVacancy },
  mixins: [
    locationVacancies,
    permissions,
  ],
  props: {
    isDisabled: Boolean,
    locationId: Number,
    locationName: String,
    value: { type: Number, default: null },
    initialText: { type: String, default: '' },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
    }
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();

      if (this.value) {
        const selected = this.items.find(i => i.id === this.value);
        if (selected && selected.vacancy_name && selected.vacancy_name.toLowerCase() === lowerQuery) return this.items;
      }

      return this.items.filter(item =>
        item.vacancy_name.toLowerCase().includes(lowerQuery)
      );
    }
  },
  methods: {
    showRecruitLocationVacancy() {
      this.$refs.recruit_location_vacancy.showModal(null, false, this.locationId, this.locationName, true, true);
    },
    async getItems() {
      if (this.locationId) {
        const result = await this.getLocationVacancyByLocationId(this.locationId);
        this.items =  (result && result.data) ? result.data.items : [];
      } else {
        const data = {
          page: 1,
          size: 1000,
        };
        const result = await this.getLocationVacancies(data);
        // TODO оставить просто null
        this.items =  (result && result.data) ? result.data.items.filter(vacancy => vacancy.location_id === 0 || vacancy.location_id === null) : [];
      }
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (!this.value && this.query) {
        this.query = "";
      }
    },
    onClick(item) {
      this.query = item.vacancy_name;
      this.$emit('onSelect', item);
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0);
    },
    // Permissions
    canEditLocationVacancies() {
      return this.hasPermission([PERM.LOCATION_VACANCY_EDIT]);
    },
  },
  watch: {
    query: {
      handler(newValue) {
        if (newValue === "" && this.value !== 0) {
          this.$emit('onSelect', 0);
        }
      }
    },
    locationId: {
      async handler(newId, oldId) {
        if (newId !== oldId) {
          this.items = [];

          await this.getItems();

          if (oldId !== undefined) {
            this.onClear();
          }
        }
      }, immediate: true
    },
    initialText: {
      handler(newValue) {
        if (this.value && !this.query && newValue) {
          this.query = newValue;
        }
      }, immediate: true
    }
  }
}
</script>

<style>
.autocomplete-input-location-vacancy {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1060;
}

.autocomplete-input-location-vacancy .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationVacancySelect.vue